<template>
    <div class="box box--3-4 zq-loyalty-rewarding-plan">
        <h2 class="box__title" v-translate>Loyalty Rewarding Plan</h2>
        <div class="box__content" v-if="loading">
            <div class="loader__overlay"><div class="loader" v-translate>Loading loyalty rewarding plan</div></div>
        </div>
        <div class="box__content" v-if="!loading">
            <h3 v-translate>Lifetime Bonus</h3>
            <p v-translate>This is bonus you receive when buying ZeeQuest products.</p>
            <div class="table__mobile-container custom-scroller--horizontal">
                <table class="table">
                    <tbody>
                        <tr>
                            <td v-translate>Purchase requirement</td>
                            <td v-for="p in plan.tiers" :key="p[0]">{{p[0]}} €</td>
                        </tr>
                        <tr class="zq-loyalty-rewarding-plan__bonuses">
                            <td v-translate>Bonus you receive</td>
                            <td v-for="p in plan.tiers" :key="p[1]">{{p[1]}}%</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        name: 'loyalty-rewarding-plan',
        data() {
            return {
                'loading': true,
                'plan': {
                }
            }
        },
        methods: {
            fetchData: async function() {
                let loyalty_url = process.env.VUE_APP_ZEEQUEST_URL + 'api/bbo/loyalty-rewarding-plan/';
                this.plan = (await axios.get(loyalty_url)).data
                this.loading = false;
            }
        },
        created: function () {
            this.fetchData()
        }
    }
</script>